/* global axios */
import ApiClient from './ApiClient';

const buildParams = params =>
  new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined)
  ).toString();

class DealAPI extends ApiClient {
  constructor() {
    super('deals', { accountScoped: true });
  }

  get({
    page = 1,
    dealStageId,
    q,
    assigneeId,
    valueMin,
    valueMax,
    status,
  } = {}) {
    const params = { page };
    if (dealStageId) params.deal_stage_id = dealStageId;
    if (q) params.q = q;
    if (assigneeId) params.assignee_id = assigneeId;
    if (valueMin !== undefined && valueMin !== '') params.value_min = valueMin;
    if (valueMax !== undefined && valueMax !== '') params.value_max = valueMax;
    if (status) params.status = status;
    const requestURL = `${this.url}?${buildParams(params)}`;
    return axios.get(requestURL);
  }

  getSummary() {
    return axios.get(`${this.url}/summary`);
  }

  getReport({ from, to }) {
    return axios.get(`${this.url}/report`, { params: { from, to } });
  }
}

export default new DealAPI();
